import axios from '../marketplace/axios-marketplace';

const getComprasPorDia = (params) => axios.get('/fornecedor/dashboard-vendas/orders-day', { params });
const getComprasPorDiaSemana = (params) => axios.get('/fornecedor/dashboard-vendas/orders-day-week', { params });
const getComprasPorSemanaMes = (params) => axios.get('/fornecedor/dashboard-vendas/orders-week-month', { params });
const getComprasPorCategoria = (params) => axios.get('/fornecedor/dashboard-vendas/categories', { params });
const getComissaoFornecedor = (params) => axios.get('/fornecedor/dashboard-vendas/supplier-fee', { params });
const getQuantidadePorSituacao = (params) => axios.get('/fornecedor/dashboard-vendas/quantity-status', { params });

const getOfertas = (params) => axios.get('/fornecedor/dashboard-vendas/sold-offers', {
  params,
});
const getVendas = (params) => axios.get('/fornecedor/compras', {
  params,
});

export default {
  getVendas,
  getOfertas,
  getComprasPorDia,
  getComprasPorDiaSemana,
  getComprasPorSemanaMes,
  getComprasPorCategoria,
  getQuantidadePorSituacao,
  getComissaoFornecedor,
};
